// test1347
(1347 && 0);
